import { Modal } from "antd";
import React, { useEffect } from "react";
import YukXatiEdit from "./YukXatiEdit";
import { useLocation, useNavigate } from "react-router-dom";

export default function YukxatiEdit_modal({ setIsModalOpen, isModalOpen }) {
  let navigate = useNavigate();
  let location = useLocation();
  useEffect(() => {
    if (!location?.search && location?.search?.length == 0) {
      setIsModalOpen(false);
      navigate(location.pathname);
    }
  }, [location?.search]);
  return (
    <Modal
      style={{ top: "10px" }}
      width={"100vw"}
      title="O'zgartir 'ЙУЛ ВАРАКАСИ'ni"
      open={isModalOpen}
      //   loading={loadVagon}
      onOk={() => {
        setIsModalOpen(false);
      }}
      onCancel={() => {
        console.log("Modal closed via Cancel button or close icon.");
        setIsModalOpen(false);
        navigate(location.pathname);
      }}
      footer={[]}
    >
      {isModalOpen ? <YukXatiEdit /> : null}
    </Modal>
  );
}
